import type { Resource } from '../../';
export const general_backToTopButton: Resource = {"default":"Top"};
